<template>
  <div class="line-chart-container" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <line-chart :chart-data="chartData" :options="chartOptions" />
  </div>
  
</template>

<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  name: 'LineChartError',
  components: {
    lineChart: {
      extends: Line,
      mixins: [reactiveProp],
      props: ['options'],
      mounted() {
        this.renderChart(this.chartData, this.options);
      },
      watch: {
        chartData() {
          this.renderChart(this.chartData, this.options);
        }
      },
      render(h) {
        return h('canvas', { ref: 'canvas' });
      }
    }
  },
  props: {
    chartData: { type: Object, required: true }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768; // Ejemplo: mobile si ancho <= 768px
    },
    chartOptions() {
      return {
        responsive: this.isMobile,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 0,
            bottom: 0
          }
        },
        legend: { display: false },
        tooltips: {
          enabled: true,
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: {
              fontColor: '#999',
              padding: 5
            }
          }],
          yAxes: [{
            gridLines: {
              color: '#e0e0e0',
              zeroLineColor: '#e0e0e0'
            },
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              min: 0,
              max: 4,
              stepSize: 1,
              padding: 5
            }
          }]
        },
        elements: {
          line: { tension: 0.3 },
          point: {
            radius: 4,
            borderWidth: 2,
            hoverRadius: 6
          }
        },
        plugins: {
          datalabels: {
            color: '#000',
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            },
            formatter: function (value) {
              return value + '%';
            }
          }
        }
      };
    }
    
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
  
};
</script>

<style scoped>
.line-chart-container {
  width: 100%;
  /* max-height: 300px; */
  position: relative;
  padding: 2rem;
}

.line-chart-container canvas {
  width: 100% !important;
  height: 100% !important;
}

.line-chart-container.mobile {
  width: 100%;
  height: auto; 
  position: relative;
}

.line-chart-container.mobile canvas {
  width: 100% !important;
  height: auto !important;
}
</style>
